<template>
  <div class="p-12px bg-color-[#fff]">
    <remote-table
      v-model:value="state.dataSource"
      ref="tableRef"
      menuName="announcementPublishPermissionConfig"
      has-action
      showSetting
      interfaceURL="announcement-publish-permission-config/page"
      :y="state.scrollY"
      :sy="state.scrollY"
      :hasPaginate="false"
      :showSelection="false"
    >
      <template #userName="{record,index}">
        <cps-select
          v-if="state.editObject[index] && !state.editObject[index].id"
          v-model:value="state.editObject[index].userId"
          url="config/list-staff"
          label="fullName"
          labelValue="id"
          showSearch
          immediate
          respField="data.list"
          class="w-full"
        ></cps-select>
        <span v-else>{{ record.userName || '-' }}</span>
      </template>
      <template #isAdminStr="{record,index}">
        <cps-select
          v-if="state.editObject[index]"
          v-model:value="state.editObject[index].isAdmin"
          :options="[
            {
              label: '是',
              value: 1
            },
            {
              label: '否',
              value: 0
            }
          ]"
          class="w-full"
        ></cps-select>
        <span v-else>{{ record.isAdminStr }}</span>
      </template>
      <template #releaseScopeStr="{record,index}">
        <cps-select
          :maxTagCount="1"
          v-if="state.editObject[index]"
          v-model:value="state.editObject[index].releaseScopeList"
          url="dict/list-dict"
          label="dictDesc"
          labelValue="dictCode"
          showSearch
          immediate
          class="w-full"
          mode="multiple"
          :params="{ dictType: 8100 }"
          valueType="number"
        ></cps-select>
        <span v-else>{{ record.releaseScopeStr }}</span>
      </template>
      <template #statusStr="{record}">
        <a-badge
          :status="
            record.status === 1
              ? 'processing'
              : record.status === 0
              ? 'default'
              : ''
          "
          :text="record.statusStr"
        />
      </template>
      <template #action="{ record,index }">
        <div v-if="state.editObject[index]">
          <a-button size="small" type="link" @click="save(index)"
            >保存</a-button
          >
          <a-button size="small" type="link" @click="cancel(index)"
            >取消</a-button
          >
        </div>
        <div v-else>
          <a-button size="small" type="link" @click="edit(record, index)"
            >编辑</a-button
          >
          <p-log
            v-if="record.id"
            type="link"
            :showButton="true"
            :logParams="{
              bizType: 8601,
              bizId: record.userId
            }"
            >日志</p-log
          >
          <a-button
            v-if="record.id"
            size="small"
            type="link"
            @click="updateStatus(record, 0)"
            :disabled="record.status === 0"
            >作废</a-button
          >
          <a-button
            v-if="record.id"
            size="small"
            type="link"
            @click="updateStatus(record, 1)"
            :disabled="record.status === 1"
            >生效</a-button
          >
        </div>
      </template>
    </remote-table>
    <a-button
      type="dashed"
      block
      class="
    w-full mt-10px text-[#1890FF] border-[#1890FF]"
      size="small"
      @click="add"
      >+ 添加</a-button
    >
  </div>
</template>
<script setup>
import { useNoticePublishConfig } from './share'
const noticePublishConfig = useNoticePublishConfig()
const {
  state,
  edit,
  save,
  cancel,
  tableRef,
  updateStatus,
  add
} = noticePublishConfig
</script>
<style lang="scss" scoped>
:deep(.portal-ant-select) {
  font-size: 12px;
}
:deep(.portal-ant-badge-status-text) {
  font-size: 12px;
}
</style>
